import { type TOC } from '@ember/component/template-only';
import { or } from 'ember-truth-helpers';
import BasicRadioGroup, {
  type Signature as BasicRadioGroupSig
} from '../basic-radio-group.gts';
import ValidatedField from '../validated-field.gts';
import ChangesetBasicRadioGroupRadioProvider, {
  type S as ChangesetBasicRadioGroupRadioProviderSig
} from './basic-radio-group/radio-provider.gts';

export interface Signature {
  Args: Pick<
    ChangesetBasicRadioGroupRadioProviderSig['Args'],
    'translationKey' | 'disabled' | 'isReadOnly' | 'changeset'
  > &
    Pick<
      BasicRadioGroupSig['Args'],
      'propertyName' | 'title' | 'isMandatory'
    > & {
      errorClass?: string;
    };
  Blocks: {
    default: [ChangesetBasicRadioGroupRadioProviderSig['Blocks']['default'][0]];
  };
}

const ChangesetBasicRadioGroup: TOC<Signature> = <template>
  <ValidatedField
    @propertyName={{@propertyName}}
    @changeset={{@changeset}}
    @errorClass={{or @errorClass 'error-validated-input-display'}}
  >
    <BasicRadioGroup
      @title={{@title}}
      @propertyName={{@propertyName}}
      @isMandatory={{@isMandatory}}
    >
      {{!
      The radio provided by the BasicRadioGroup are not using the changeset
      so we have to provide the right ones by using thisspecific radio provider.
    }}
      <ChangesetBasicRadioGroupRadioProvider
        @translationKey={{@translationKey}}
        @changeset={{@changeset}}
        @propertyName={{@propertyName}}
        @isReadOnly={{@isReadOnly}}
        @disabled={{@disabled}}
        as |provider|
      >
        {{yield provider}}
      </ChangesetBasicRadioGroupRadioProvider>
    </BasicRadioGroup>
  </ValidatedField>
</template>;

export default ChangesetBasicRadioGroup;
